<template>
    <nav class="bg-white md:border-b" ref="nav">
        <mobile-nav :home="home">
            <slot />
        </mobile-nav>

        <desktop-nav :home="home">
            <slot />
        </desktop-nav>
    </nav>
</template>

<script>
import MobileNav from '@/components/shared/MobileNav.vue'
import DesktopNav from '@/components/shared/DesktopNav.vue'

export default {
    props: {
        home: {
            type: String,
            required: true
        }
    },
    components: {
        MobileNav,
        DesktopNav,
    }
}
</script>
